import { atomWithStorage } from "jotai/utils";

export const addSenderTabAtom = atomWithStorage<number>("addSenderTab", 0);
export const sendersTabAtom = atomWithStorage<number>("sendersTab", 0);
